module.exports = __webpack_public_path__ + "static/media/cc2.ced71835.jpg";